export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/errors/error-429.png";